<template>
  <div>
    <div padding>
      <ion-title>{{ title }}</ion-title>
    </div>
    <search-notes
      v-if="flow === 0"
      :select-mode="true"
      @input="onSelectNotebook"
    ></search-notes>

    <div v-if="flow === 1">
      <div class="text-preview">
        <p v-html="text"></p>
      </div>
      <ion-title style="color: var(--ion-color-primary); font-weight: 600;margin-top: 0.7em;">{{ notebook.title }}</ion-title>
      <ion-list>
        <ion-item
          v-for="(section, idx) in sections"
          :key="idx"
          button
          @click="addHere(idx)"
        >
          <ion-icon v-if="section == 'Add at the end of the notebook'" style="margin-right: 0.3em;" name="return-right"></ion-icon>
          <ion-icon v-if="section == 'Add new section'" style="margin-right: 0.3em;" name="add-circle"></ion-icon>
          <ion-label>{{ section.replace(/<[^>]*>/g, "") }}</ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    docs: Array,
    docType: String
  },

  data() {
    return {
      notebook: {},
      sections: [],
      lines: [],
      flow: 0,
      add: '',
      text: ''
    };
  },

  methods: {
    async loadSections() {
      var res = await this.$lawyerly.casebooks.view({ id: this.notebook.id });
      if (res.data.count) {
        this.notebook = res.data.result[0];
      }
      this.lines = (this.notebook.content || "")
      .replace(/(\r\n|\n|\r)/gm, '')
      .replace(/></g, '>,,<')
      .split(',,');
      this.sections = [
        ...this.lines
          .filter(l => {
            return l.trim().startsWith("<h");
          }),
        "Add at the end of the notebook",
        "Add new section",
      ];
    },

    addWhat() {
      var text = "";
      if (window.getSelection) {
          text = window.getSelection().toString();
      } else if (document.selection && document.selection.type != "Control") {
          text = document.selection.createRange().text;
      }

      if(this.$store.state.ui.text) {
        text = this.$store.state.ui.text;
         this.$store.commit("ui/setText", null);
      }

      var c = "";
      this.docs.forEach(d => {
        if(text) {
          this.text = text;
          c += `<a href="${this.docType}://${d.docid}">${d.shortTitle}</a></p><blockquote><p>${text}</p></blockquote>\n`;
        } else {
          this.text = `<p><a>${d.shortTitle}</a></p>`;
          c += `<p><a href="${this.docType}://${d.docid}">${d.shortTitle}</a></p>\n`;
        }
      });
      return c;
    },

    async addHere(idx) {
      let out = "";

      if(this.sections[idx] == 'Add new section') {
        this.$ionic.showAlert("",
          {
            cssClass: "medium-width-alert",
            header: "Add new section",
            // subHeader: ,
            inputs:[
              {
                name: 'title',
                placeholder: 'Title'
              }
            ],
            buttons: [{ text: "Add", handler: alertData => (this.addSection(alertData.title)) }, "Cancel"]
          }
        );
        return;
      }

      if(!this.sections[idx+1].startsWith('<h')) {
        out = this.notebook.content + this.add;
      } else {
        const section = this.sections[idx+1];
        out = this.notebook.content.replace(section, `${this.add}$&`);
      }

      // var c = "";
      // var added = false;
      // var found = false;
      // this.lines.forEach(l => {
      //   var lt = l.trim();
      //   c += l + "\n";
      //   if (lt === section) {
      //     found = true;
      //     return;
      //   }
      //   if ((lt === "" || lt.startsWith("#")) && found && !added) {
      //     c += this.addWhat() + "\n";
      //     added = true;
      //   }
      // });

      // if (!added) {
      //   c += this.addWhat() + "\n";
      // }

      // save
      this.notebook.content = out;
      var res = await this.$lawyerly.casebooks.update(this.notebook);
      if (res.data && res.data.id) {
        this.$ionic.showToast(`Added to ${this.notebook.title}.`, {
          position: "top"
        });
      } else {
        this.$ionic.showToast("Unable to save.", {
          position: "top"
        });
      }

      this.$ionic.dismissPopover();
    },

    onSelectNotebook(note) {
      this.notebook = note;
      this.flow++;
      this.loadSections();
      this.add = this.addWhat();
    },

    async addSection(title) {
      let out = this.notebook.content + `<h1>${title}</h1>`;
      this.notebook.content = out;
      var res = await this.$lawyerly.casebooks.update(this.notebook);
      if (res.data && res.data.id) {
        this.loadSections();
      } else {
        this.$ionic.showToast("Unable to add section.", {
          position: "top"
        });
      }
    }
  },

  computed: {
    title() {
      switch (this.flow) {
        case 0:
          return "Select Notebook";
        case 1:
          return "Select Section";
        case 2:
          return "Create Section";
      }
    }
  },

  components: {
    "search-notes": () =>
      import(/* webpackChunkName: "notebooks" */ "@/views/notebooks/Search.vue")
  }
};
</script>
<style>
.text-preview {
  background: #f0f0f0;
  padding: 1.5em;
}
.text-preview p{
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 82px;
  text-align: justify;
}
</style>
